import styled from "styled-components";

export const AddressContainer = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  height: fit-content;
  padding: 20px;
  background-color: #FAFBFC;
  filter: drop-shadow(0px 2px 4px rgba(0, 0, 0, 0.4));
  /* box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1), 0px 1px 3px rgba(0, 0, 0, 0.06); */
`;

export const DeliveryOptionIcon = styled.img`
    margin-right: 20px;
    width: 20px;
    max-height: 25px;
`;

export const AddressInformation = styled.div`
    display: flex;
    flex-direction: column;
`;

export const AddressMessage = styled.span`
    font-size: 14px;
    color: #333;
`;

export const AddressDetails = styled.span`
    font-weight: bold;
    font-size: 12px;
    color: #333;
`;

export const ArrowIcon = styled.img`
    position: absolute;
    height: 15px;
    right: 20px;
`;